// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sc-1";
export var stateContainer = "_sc-0";